import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { EscalatedRisk } from '../../_interfaces/EscalatedRisk.model';
import { RepositoryService } from './../../shared/services/repository.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RiskUser } from '../../_interfaces/RiskUser.model';
import { Risk} from "../../_interfaces/risk.model";
import { RiskSummary } from '../../_interfaces/RiskSummary.model';

@Component({
  selector: 'app-edit-escalated-risk',
  templateUrl: './edit-escalated-risk.component.html',
  styleUrls: ['./edit-escalated-risk.component.css']
})
export class EditEscalatedRiskComponent implements OnInit {
  riskDetail: EscalatedRisk;
  riskEditForm: FormGroup;
  submitted = false;
  riskUsers: RiskUser[];

  public riskSummary: RiskSummary;
  public opRiskTypes: string[];
  public stratRiskTypes: string[];
  public finRiskTypes: string[];

  constructor(private formBuilder: FormBuilder,
    private repository: RepositoryService,
    private router: Router,
    private activeRoute: ActivatedRoute) { }

  public risks: Risk[];

  ngOnInit() {

    this.opRiskTypes = ['',
      'Business Continuity Risk',
      'Process Risk',
      'Cyber and Data Security Risk',
      'Technology Risk',
      'Legal and Regulatory Risk',
      'Conduct Risk',
      'Outsourcing Risk and 3rd Party Risk',
      'People Risk'];

    this.stratRiskTypes = ['',
      'New Business',
      'Strategic and Structural Issues',
      'Political Legal and Regulatory',
      'Macro-Economic Environment',
      'Infrastructure',
      'Project',
    ];

    this.finRiskTypes = ['',
      'Market',
      'Default',
      'Life',
      'Health',
      'Liquidity',
      'Pension',
      'Asset Share']

    this.riskDetail = new EscalatedRisk();

    this.riskEditForm = this.formBuilder.group({
      description: ['', Validators.required],
      reviewDetails: ['', Validators.required],
      reviewResult: ['', Validators.min(0)],
      toBeReviewedBy: ['', Validators.required, Validators.min(0)],

      riskType: [''],
      strategicRiskType: [''],
      operationalRiskType: [''],
      financialRiskType: [''],

      relatedRiskId: ['', Validators.required, Validators.min(0)],
    });



    this.getPeople();
    this.getHorizonScanById();
  }

  public getHorizonScanById() {
    let id: string = this.activeRoute.snapshot.params['id'];
    let apiUrl: string = `escalatedRisks/${id}`;

    this.repository.getData(apiUrl)
      .subscribe(res => {
        this.riskDetail = res as EscalatedRisk;
        this.updateFormFromRisk();
      });
  }


  onSubmit() {
    this.submitted = true;
    this.updateRiskFromForm();

    this.putRiskDetails();
  }

  onCancelForm() {
    this.router.navigate([`/myrisks/escalated`]);
  }

  updateRiskFromForm() {
    if (this.f.reviewResult.value) {
      this.riskDetail.reviewResult = + this.f.reviewResult.value;
    }

    if (this.f.toBeReviewedBy.value) {
      this.riskDetail.toBeReviewedBy = + this.f.toBeReviewedBy.value;
    }

    if (this.f.relatedRiskId.value) {
      this.riskDetail.relatedRiskId = + this.f.relatedRiskId.value;

    }

    // non-numeric fields
    this.riskDetail.description = this.f.description.value;
    this.riskDetail.reviewDetails = this.f.reviewDetails.value;
  }

  updateFormFromRisk() {


    // non-numeric fields
    this.f.description.setValue(this.riskDetail.description);
    this.f.reviewDetails.setValue(this.riskDetail.reviewDetails);

    if (this.riskDetail.reviewResult) {
      this.f.reviewResult.setValue(+ this.riskDetail.reviewResult);
    }

   

    if (this.riskDetail.relatedRiskId) {
      // Set up Risk Types dropdowns
      this.getRelatedRisk(this.riskDetail.relatedRiskId.toString());

      // ToDo - set up related risk dropdown
      // this.f.relatedRiskId.setValue(+ this.riskDetail.relatedRiskId);

    }

    if (this.riskDetail.toBeReviewedBy) {
      this.f.toBeReviewedBy.setValue(+ this.riskDetail.toBeReviewedBy);
    }

  }

  putRiskDetails() {
    let apiAddress: string = `escalatedrisks`;

    this.repository.update(apiAddress, this.riskDetail)
      .subscribe(res => {
        // this.riskDetail = res as Risk;
        //this.router.navigate(["../../risks"], { relativeTo: this.activeRoute });
        this.router.navigate([`/myrisks/escalated`]);
      }, error => {
        alert('Error:!' + error.message + '\n\n');
        this.router.navigate([`/myrisks/escalated`]);
      },
        () => this.navAfterSubmit()
      );
  }

  public navAfterSubmit() {
    if (this.riskDetail.reviewResult == 2  ) {
      let addRiskUrl: string = `/myrisks/add-risk`;
      this.router.navigate([addRiskUrl]);
    }
    else {
      this.router.navigate([`/myrisks/escalated`])
    }
  }

  public getPeople() {
    let apiAddress: string = `Users/UserList`;
    this.repository.getData(apiAddress)
      .subscribe(res => {
        const riskUsers = res as RiskUser[];
        this.riskUsers = riskUsers.filter(this.isRiskAdmin);
      });
  }

  public getFinancialRisks(finRiskType: string) {
    let apiAddress: string = `Risks/Financial/` + finRiskType;
    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.risks = res as Risk[];
      });
  }
  public getOperationalRisks(opRiskType: string) {
    let apiAddress: string = `Risks/Operational/` + opRiskType;
    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.risks = res as Risk[];
      });
  }
  public getStrategicRisks(stratRiskType: string) {
    let apiAddress: string = `Risks/Strategic/` + stratRiskType;
    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.risks = res as Risk[];

      });
  }

  public isActive = (element, index, array) => {
    return (element.dormant === 0);
  };

  public isRiskAdmin = (element, index, array) => {
    return (element.superAdmin === 1 && element.dormant === 0);
  };

  get f() { return this.riskEditForm.controls; }

  public getRelatedRisk(RiskId: string) {
    // this.selectedRisk = RiskId;

    let id: string = RiskId;
    let apiUrl: string = `RiskSummary?id=${id}`;

    this.repository.getData(apiUrl)
      .subscribe(res => {
        this.riskSummary = res as RiskSummary;
        if (this.riskSummary.riskType > 0) {
          this.f.riskType.setValue(this.riskSummary.riskType);
          this.f.riskType.updateValueAndValidity();
          // find and set OP/Fin/Strat risk type values into dropdown
          if (this.riskSummary.strategicRiskType != null) {
            this.getStrategicRisks(this.stratRiskTypes[this.riskSummary.strategicRiskType]);
            this.f.strategicRiskType.setValue(this.stratRiskTypes[this.riskSummary.strategicRiskType]);
            //this.f.strategicRiskType.updateValueAndValidity();
          }
          if (this.riskSummary.operationalRiskType != null) {
            this.getOperationalRisks(this.opRiskTypes[this.riskSummary.operationalRiskType]);
            this.f.operationalRiskType.setValue(this.opRiskTypes[this.riskSummary.operationalRiskType]);
            
          }
          if (this.riskSummary.financialRiskType != null) {
            this.getFinancialRisks(this.finRiskTypes[this.riskSummary.financialRiskType]);
            this.f.financialRiskType.setValue(this.finRiskTypes[this.riskSummary.financialRiskType]);
            
          }
        }

        this.f.relatedRiskId.setValue(+ this.riskDetail.relatedRiskId);

      });
  }
  // --
}
